export const localStorageKeys = {
  restructuring_in_progress: (accountId: string) => `${accountId}_restructuring_in_progress`,
};

export type LocalStorageValues = {
  restructuring_in_progress: string; // total count of loans created from restructures on an account
};
